import React, { useEffect } from "react";
import Select from "react-select";
import { useUnitHolderSearch } from "../hooks/useSearchUnitholder";
import { useCustomStylesDropDown } from "../assets/css/customStyle";
interface SelectUnitholdersProps {
  folioNo: string | null;
  onChange: any;
  customStyles?: any;
}

const SelectUnitholders: React.FC<SelectUnitholdersProps> = ({
  folioNo,
  onChange,
}) => {
  const email = sessionStorage.getItem("email") || "";
  const { customStyles } = useCustomStylesDropDown();
  const {
    unitholderOptions,
    unitholderLoading,
    searchUnitholders,
    fetchInitialUnitholders,
  } = useUnitHolderSearch(email);

  useEffect(() => {
    fetchInitialUnitholders();
  }, []);

  return (
    <div className="form-group">
      <label>Select Folio No.</label>
      <Select
        options={unitholderOptions || []}
        onChange={onChange}
        onInputChange={(inputValue, { action }) => {
          if (action === "input-change") {
            searchUnitholders(inputValue);
          }
        }}
        placeholder="Search by folio number or name..."
        isLoading={unitholderLoading}
        isClearable
        value={
          unitholderOptions?.find((opt) => opt.folio_no === folioNo) || null
        }
        noOptionsMessage={() =>
          unitholderLoading
            ? "Searching..."
            : "No unitholders found. Try a different search."
        }
        filterOption={null}
        styles={customStyles}
      />
    </div>
  );
};

export default SelectUnitholders;
